import CommonError from '../Common/CommonError'

const Error403Container = () => {
  return (
    <CommonError error="403" color="success" src="sad2" />
  )
}

export default Error403Container